import {
    Error,
    GetAllFiles,
    GetOneFile,
    DeleteOneFile,
    InsertOneFile,
    UpdateOneFile,
    GetAllFilesDetailsmulit,
    GetSubUsersFiles
  } from "../type";
  const initialState = {
    Files: [],
    CreateFiles: [],
    FiledMulit:[],
    DeleteFile: [],
    UpdateFile: [],
    SubUsersFiles:[],
    OneFile:[],
    loading: false,

  };
  const FileR = (state = initialState, action) => {
    switch (action.type) {
      case GetAllFiles:
        return {
          ...state,
          Files: action.payload,
          loading: false,
        };
        case GetAllFilesDetailsmulit:
          return {
            ...state,
            Files: action.payload,
            loading: false,
          };
        case GetSubUsersFiles:
          return {
            ...state,
            SubUsersFiles: action.payload,
            loading: false,
          };
      case GetOneFile:
        return {
          OneFile: action.payload,
          loading: false,
        };
      case InsertOneFile:
        return {
          Files:state.Files,
            CreateFiles: action.payload,
           loading: false,
        };
      case UpdateOneFile:
        return {
          Files:state.Files,
            UpdateFile: action.payload,
          loading: false,
        };
      case DeleteOneFile:
        return {
          Files:state.Files,
          DeleteFile: action.payload,
          loading: false,
        };
      case Error:
        return {
          loading: false,
          Files: action.payload,
        };
      default:
        return state;
    }
  };
  export default FileR;
  